import { render } from "./ThongKeDieuTri.vue?vue&type=template&id=af17195c&scoped=true&ts=true"
import script from "./ThongKeDieuTri.vue?vue&type=script&lang=ts"
export * from "./ThongKeDieuTri.vue?vue&type=script&lang=ts"

import "./ThongKeDieuTri.vue?vue&type=style&index=0&id=af17195c&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af17195c"]])

export default __exports__